import { SKU_SPLITER } from '@/constants';
import type { AnyObj } from '@/types';
import type { Commodity } from '@/types/global-business';
import { commonUtils } from '../common';

export default {
  /**
   * 组合sku
   * @param data
   */
  cartesianProductOf: (data: AnyObj) => {
    return Array.prototype.reduce.call(
      data,
      function (a: any, b: any) {
        let sku: any[] = [];
        a.forEach(function (a: any[]) {
          b.attrs.forEach(function (b: any) {
            sku.push(a.concat([b]));
          });
        });
        return sku;
      },
      [[]]
    );
  },
  /**
   * 根据sku组合数据得到路径字典对象
   * @param skus
   * @returns
   */
  getPathMap: (skus: any[]) => {
    const pathMap = {};

    skus.forEach((sku) => {
      // 筛选出有库存有效的sku 或者 虚拟商品处于可用状态
      if (sku.inventory && sku.isVirtualAvailable && sku.canPointExchange) {
        // 得到sku属性值数组
        const values = sku.values.map((s: any) => s.code);
        // 得到sku属性值数组的子集
        const powerSet = commonUtils.data.bwPowerSet(values);
        // 设置给路径字典对象
        powerSet.forEach((set) => {
          const key = set.join(SKU_SPLITER);
          if (pathMap[key]) {
            // 已经有key往数组追加
            pathMap[key].push(sku.id);
          } else {
            // 没有key设置一个数组
            pathMap[key] = [sku.id];
          }
        });
      }
    });

    return pathMap;
  },
  /**
   * 通过options组合sku显示文本
   * @param options
   * @returns
   */
  getText: (options: AnyObject[]) => {
    return options?.map((oi: AnyObj) => oi.name)?.join(' | ') ?? '';
  },
  /**
   * 是否隐藏立即购买
   * @param sku
   */
  isHidePurchaseNow(sku: Commodity.SkuType | null) {
    const isCanPurchase = sku?._source?.isCanPurchase;

    if (typeof isCanPurchase === 'boolean' && !isCanPurchase) {
      return true;
    }

    return false;
  },
};

// export const mockSkuOptions = [
//   {
//     id: 1,
//     name: '颜色',
//     attrs: [
//       { id: 101, name: '黑色' },
//       { id: 102, name: '白色' },
//     ],
//   },
//   {
//     id: 2,
//     name: '套餐',
//     attrs: [
//       { id: 200, name: '套餐一' },
//       { id: 201, name: '套餐二' },
//     ],
//   },
//   {
//     id: 3,
//     name: '内存',
//     attrs: [
//       { id: 300, name: '64G' },
//       { id: 301, name: '128G' },
//       { id: 302, name: '256G' },
//     ],
//   },
// ];
